import { Module } from 'vuex'

import { QlogState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: QlogState = {
  isLogsLoading: false,
  logs: [],
}

export const qlog: Module<QlogState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
